"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var HideScrollBar = function HideScrollBar() {
  return "\n  -ms-overflow-style: none;  // IE 10+\n  overflow: -moz-scrollbars-none;  // Firefox\n\n  &::-webkit-scrollbar {\n    display: none;  // Safari and Chrome\n  }\n";
};

exports.default = HideScrollBar;